import { AssistantReservationGroup } from '@mews-commander/data-access';
import { IconName } from '@optimus-web/core';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { ResultListProps } from '../results/ListTitle';
import { highlight } from '../../utils/highlight';
import { navigateInBaseModal } from '../../../app/actions/common';
import { StyledLeftIcon } from '../styles';
import { SearchType } from '../../assistantSearchTypes';
import { AssistantSearchListItemProps } from './useAssistantSearchResultListMap';

interface ReservationGroupListProps extends ResultListProps {
    reservationGroups: AssistantReservationGroup[];
}

export const useReservationGroupList = ({
    reservationGroups,
    searchTerm,
}: ReservationGroupListProps): AssistantSearchListItemProps[] => {
    const resolveRoute = useResolveRoute();
    return reservationGroups.map((reservationGroup) => {
        const url = resolveRoute(RouteName.ReservationGroupDetail, { id: reservationGroup.id });
        return {
            itemId: reservationGroup.id,
            primaryText: highlight(reservationGroup.name, searchTerm),
            leftIcon: <StyledLeftIcon size="small" value={IconName.ReservationGroup} />,
            routeAction: navigateInBaseModal(url),
            searchType: SearchType.ReservationGroup,
        };
    });
};
